import { Directive, Input, ElementRef, OnChanges, AfterViewInit } from '@angular/core';

declare const feather: any;

@Directive({
  selector: '[appFeather]',
  standalone: true
})
export class FeatherIconDirective implements AfterViewInit, OnChanges {
  @Input('appFeather') iconName = '';
  @Input() size    = '16';
  @Input() stroke  = 'currentColor';
  @Input() fill    = 'none';

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void { this.renderIcon(); }
  ngOnChanges():     void { this.renderIcon(); }

  private renderIcon(): void {
    try {
      if (typeof feather === 'undefined' || !this.iconName) return;
      const svg = feather.icons[this.iconName]?.toSvg({
        width:          this.size,
        height:         this.size,
        stroke:         this.stroke,
        fill:           this.fill,
        'stroke-width': '2',
        'stroke-linecap':  'round',
        'stroke-linejoin': 'round'
      });
      if (svg) this.el.nativeElement.innerHTML = svg;
    } catch { /* icon not found — keep existing content */ }
  }
}
